import api from "./api";

// Fetch all driver wallets
export const fetchDriverWallets = async () => {
  try {
    const response = await api.get(
      "/driver-wallet-management/driver-wallets"
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    return {
      success: false,
      error:
        response.data?.message ||
        "Unexpected response from server",
    };
  } catch (error) {
    console.error(
      "Error fetching driver wallets:",
      error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch driver wallets.",
    };
  }
};

// Admin complimentary wallet top-up
export const adminTopUpWallet = async (
  driverId,
  amount
) => {
  try {
    const response = await api.post(
      `/driver-wallet-management/driver-wallet/admin-top-up/${driverId}`,
      {
        amount,
      }
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    return {
      success: false,
      error:
        response.data?.message ||
        "Unexpected response from server",
    };
  } catch (error) {
    console.error(
      "Error topping up wallet:",
      error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to top up wallet.",
    };
  }
};